import { http } from '@/core/api/';
import qs from 'querystring';

const axiosConfig = (properties) => ({
  params: {
    ...properties,
  },
  paramsSerializer: (params) => qs.stringify(params),
});

export default {
  getRegions(properties) {
    return http.get('api/location/regions', axiosConfig(properties));
  },
  getDistricts(properties) {
    return http.get('api/location/districts', axiosConfig(properties));
  },
  getMunicipalities(properties) {
    return http.get('api/location/municipalities', axiosConfig(properties));
  },
  getSchools(properties) {
    return http.get('api/location/schools', axiosConfig(properties));
  },
  getSchoolById(locationSchoolId) {
    return http.get(
      `api/schools/getlocationschooladdress`,
      axiosConfig({ locationSchoolId })
    );
  },
  getSchoolsWithCustodian(properties) {
    return http.get(
      'api/location/schoolswithcustodian',
      axiosConfig(properties)
    );
  },
  getCenters(properties) {
    return http.get('api/location/centers', axiosConfig(properties));
  },
  getProviderCenters(properties) {
    return http.get('api/location/providercenters', axiosConfig(properties));
  },
  getProviderMunicipalities(properties) {
    return http.get(
      'api/location/providermunicipalities',
      axiosConfig(properties)
    );
  },
  getProviderSchools(properties) {
    return http.get('api/location/providerschools', axiosConfig(properties));
  },
  isPublicSchool(locationSchoolId) {
    return http.get(`api/schools/ispublicschool/${locationSchoolId}`);
  },
  isSSNValidForAssistant(
    ssn,
    isPublicSchool = true,
    isSSNCreatedFromDB = false
  ) {
    return http.get(
      `api/schools/isassistantssnforschool/${ssn}?isPublicSchool=${isPublicSchool}&isSSNCreatedFromDB=${isSSNCreatedFromDB}`
    );
  },
  generateUniqueRandomSSN() {
    return http.get(`api/schools/generaterandomssn`);
  },
  addNewAssistant(payload) {
    return http.post(`api/schools/saveassistantforschool`, payload);
  },
};
